import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";

const Hero = () => (
  <section
    className="hero-section d-flex align-items-center position-relative overflow-hidden"
    style={{
      minHeight: "100vh",
      background:
        "linear-gradient(135deg, #E7F5F2 0%, #F9FAFA 40%, #ffffff 100%)",
    }}
  >
    {/* Arka plan dekoratif şekiller */}
    <div
      className="position-absolute top-0 end-0 translate-middle opacity-50"
      style={{
        width: "600px",
        height: "600px",
        background: "radial-gradient(circle, #7DD1C0 0%, transparent 70%)",
        filter: "blur(100px)",
        zIndex: 0,
      }}
    ></div>

    <Container style={{ position: "relative", zIndex: 2 }}>
      <Row className="align-items-center">
        {/* Sol taraf */}
        <Col md={6} className="text-center text-md-start">
          <motion.h1
            className="fw-bold display-4 mb-3"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            style={{
              color: "#2D8A7A",
              lineHeight: "1.2",
            }}
          >
            Majistral Formül Veri Tabanı: 
            <span style={{ color: "#7DD1C0" }}> Majistral App</span> Sizlerle!
          </motion.h1>

          <motion.p
            className="lead text-muted mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            Majistral formüller, formüllerin hazırlanışları ve klinik bilgiler tek bir dijital platformda. Eczacı, hekim ve akademisyenlere özel!
          </motion.p>

          <motion.div
            className="d-flex justify-content-center justify-content-md-start gap-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            <Button
              size="lg"
              variant="primary"
              className="px-4 hover-scale"
              href="/register"
            >
              Hemen Üye Ol <FaArrowRight className="ms-2" />
            </Button>

            <Button
              size="lg"
              variant="outline-primary"
              className="px-4 hover-scale"
              href="#pricing"
            >
              Fiyatlandırma
            </Button>
          </motion.div>
        </Col>

        {/* Sağ taraf (görsel/illustrasyon) */}
        <Col md={6} className="mt-5 mt-md-0 text-center">
          <motion.img
            src="/logo512.png"
            alt="Majistral App"
            className="img-fluid floating hero-image-mobile-small"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            style={{
              maxHeight: "420px",
              objectFit: "contain",
              filter: "drop-shadow(0 8px 20px rgba(0,0,0,0.08))",
            }}
          />
        </Col>
      </Row>
    </Container>
  </section>
);

export default Hero;